import { format } from 'date-fns';

export default class DateHelper {
  static getFirstDateOfMonth(): Date {
    const now = new Date();
    const date = new Date(now.getFullYear(), now.getMonth(), 1);
    return DateHelper.addNorwegianTimezone(date);
  }

  static getFirstDayOfYear(): Date {
    const now = new Date();
    const date = new Date(now.getFullYear(), 0, 1);
    return DateHelper.addNorwegianTimezone(date);
  }

  // check if the object is a Date type
  static isDate = (date) => date instanceof Date;

  static formatDate = (date, dateFormat = 'dd.MM.yyyy') => {
    if (!date) return '';
    if (!DateHelper.isDate(date)) {
      return format(new Date(date), dateFormat);
    }
    return format(date, dateFormat);
  };

  // returns a new Date object with the specified days added
  static addDays = function (date: Date, days: number) {
    const copy = new Date(date.getTime());
    copy.setDate(date.getDate() + days);
    return copy;
  };

  // if date is a string try to parse into a date object
  static ensureDate = (date) => {
    if (!date) return null;
    if (!DateHelper.isDate(date)) {
      return new Date(date);
    }
    return date;
  };

  static addNorwegianTimezone = (date: Date | undefined): Date | undefined => {
    if (!date) return undefined;

    // Norway is UTC+1 (CET) in winter and UTC+2 (CEST) in summer
    // Get the timezone offset for Norway
    const norwayDate = new Date(date.toLocaleString('en-US', { timeZone: 'Europe/Oslo' }));
    const utcDate = new Date(date.toLocaleString('en-US', { timeZone: 'UTC' }));
    const timezoneOffset = norwayDate.getTime() - utcDate.getTime();

    // Add the Norwegian timezone offset to the selected date
    return new Date(date.getTime() + timezoneOffset);
  };
}
